import React, { useState } from 'react';
import { Box, Grid, TextField, Button, Typography, Paper } from '@mui/material';
import Swal from 'sweetalert2';

const ContactForm = () => {
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(event.target);
    formData.append("access_key", "90609f60-90ad-411c-a05c-06754b24ede0");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      }).then((res) => res.json());

      if (res.success) {
        Swal.fire({
          title: "Success",
          text: "You have Submitted the message!",
          icon: "success"
        });
        setFormValues({
          name: '',
          email: '',
          message: '',
        });
      } else {
        console.error("Submission failed:", res);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 4, border: '3px solid violet', backgroundColor: 'black' }}>
      <Typography variant="h5" color="white" gutterBottom>
        Contact Me
      </Typography>
      <form onSubmit={onSubmit}>
        <TextField
          sx={{ color: 'white', backgroundColor: 'white' }}
          fullWidth
          label="Name"
          name="name"
          value={formValues.name}
          onChange={handleChange}
          variant="filled"
          margin="normal"
          required
        />
        <TextField
          sx={{ color: 'white', backgroundColor: 'white' }}
          fullWidth
          label="Email"
          name="email"
          value={formValues.email}
          onChange={handleChange}
          variant="filled"
          margin="normal"
          required
        />
        <TextField
          sx={{ color: 'white', backgroundColor: 'white' }}
          fullWidth
          label="Message"
          name="message"
          value={formValues.message}
          onChange={handleChange}
          variant="filled"
          margin="normal"
          multiline
          rows={4}
          required
        />
        <Button
          variant="contained"
          sx={{ color: 'white', backgroundColor: 'green' }}
          type="submit"
          disabled={isSubmitting}
        >
          Send Message
        </Button>
      </form>
    </Paper>
  );
};

const Conform = () => {
  return (
    <Box id='contact' sx={{ flexGrow: 1, pt: 25, pl: 4, pr: 4 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <iframe
            title='This is My Current Location'
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3826.6644981422405!2d80.62035802466372!3d16.441857079355575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f0a2a073957d%3A0xe79d66babc83e470!2sK%20L%20UNIVERSITY%2C%20Vaddeswaram%2C%20Andhra%20Pradesh%20522303!5e0!3m2!1sen!2sin!4v1724585478162!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Grid>
        <Grid item xs={12} md={6}>
          <ContactForm />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Conform;
